import UserDropdown from "components/Dropdowns/UserDropdown.js";
export default function Navbar() {
 

  return (
    <>
      <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-0">
        <div className="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-15 px-0">
          <a
            className="text-white text-sm uppercase hidden lg:inline-block font-semibold"
            href="#pablo"
            onClick={(e) => e.preventDefault()} 
          >
          
          </a>
   
          <form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-">
            <div className="relative flex w-full flex-wrap items-stretch">
              <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
               
              </span>
             
            </div>
          </form>
         
          {/* <ul className="flex-col md:flex-row list-none items-center hidden md:flex">
            <UserDropdown />
          </ul> */}
        </div>
      </nav>
    
    </>
  );
}
